export enum AppRoutes {
    MAIN = "main",
    LOGIN = "login",
    VIDEO = "video",
    NOT_FOUND = "not_found",
}
